import { useFormContext } from 'react-hook-form';

import { FILE_SIZE_LIMIT } from '@xemplo/gp-constants';
import { MaybeErrorOrDescription } from '@xemplo/input-utils';

import { RejectEarningLinesType } from '../payrun-approve-reject.types';

import * as S from './reject.styles';

export const RejectAttachment = () => {
  const { register, getFieldState } = useFormContext<RejectEarningLinesType>();

  return (
    <S.UploadContainer>
      <S.Label htmlFor="attachment">Attachment</S.Label>
      <S.FileInput
        type="file"
        {...register('attachment', {
          validate: (value) => {
            if (value && value[0]?.size > FILE_SIZE_LIMIT) {
              return `File size must be less than ${FILE_SIZE_LIMIT / (1024 * 1024)} MB`;
            }
            return true;
          },
        })}
        accept=".csv, .xlsx, .txt, .pdf, .zip"
      />

      <MaybeErrorOrDescription
        error={getFieldState('attachment')?.invalid}
        errorMessage={getFieldState('attachment')?.error?.message}
      />
    </S.UploadContainer>
  );
};
